import React, { useState, useRef, useEffect } from 'react';
import { Button } from 'rhombus-react';

const STATUSES = {
	LOADING: { label: 'Preview', icon: 'fa-regular fa-circle-play', isDisabled: true },
	PREVIEW: { label: 'Preview', icon: 'fa-regular fa-circle-play', isDisabled: false },
	STOP: { label: 'Stop', icon: 'fa-regular fa-circle-stop', isDisabled: false },
};

const AudioButton = ({ src }) => {
	const [status, setStatus] = useState(STATUSES.LOADING);
	const audioRef = useRef();

	const onLoadedData = () => {
		setStatus(STATUSES.PREVIEW);
	};

	useEffect(() => {
		setStatus(STATUSES.LOADING);
	}, [src]);

	useEffect(() => {
		const onPlay = () => setStatus(STATUSES.STOP);
		const onPause = () => setStatus(STATUSES.PREVIEW);
		audioRef.current?.addEventListener('play', onPlay);
		audioRef.current?.addEventListener('pause', onPause);
		return () => {
			audioRef.current?.removeEventListener('play', onPlay);
			audioRef.current?.removeEventListener('pause', onPause);
		};
	}, []);

	const onClick = () => {
		if (status === STATUSES.PREVIEW) {
			audioRef.current?.play();
		} else {
			audioRef.current?.pause();
		}
	};

	return (
		<Button
			className="gen-audio-button play-audio-button"
			icon={status.icon}
			onClick={onClick}
			disabled={status.isDisabled}
		>
			{status.label}
			<audio
				ref={audioRef}
				src={src}
				preload="auto"
				onLoadedData={onLoadedData}
			/>
		</Button>
	);
};

export default AudioButton;
